import React from 'react';
import { Link } from 'react-router-dom';
import { User, LogIn } from 'lucide-react';
import { Button } from './ui/button';

const HeaderAuth = () => {
  // Check customer token (not venue owner token)
  const token = localStorage.getItem('customerToken');
  const userStr = localStorage.getItem('customer');
  const user = userStr ? JSON.parse(userStr) : null;

  if (token && user) {
    return (
      <Link to="/hesabim">
        <Button 
          variant="outline" 
          size="sm" 
          className="flex items-center gap-2 border-pink-500 text-pink-600 hover:bg-pink-50 hover:text-pink-700"
        >
          <User className="w-4 h-4" />
          <span>{user.name || 'Hesabım'}</span>
        </Button>
      </Link>
    );
  }

  return (
    <Link to="/uye-giris">
      <Button 
        size="sm" 
        className="flex items-center gap-2 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white border-0"
      >
        <LogIn className="w-4 h-4" />
        <span>Üye</span>
      </Button>
    </Link>
  );
};

export default HeaderAuth;
